import { BehaviorSubject } from 'rxjs';
import { ApiDataSource } from '../api.data-source';
import { debounceTime, finalize, tap } from 'rxjs/operators';
import { CustomerExperienceQuestionAnswer, CustomerExperienceQuestionAnswerService } from '@core/api';

export class CustomerExperienceQuestionAnswerDataSource extends ApiDataSource<CustomerExperienceQuestionAnswer> {

    public isOpenedNewTab = false;

    public request$ = new BehaviorSubject<{}>(null);

    constructor(
        private questionAnswerService: CustomerExperienceQuestionAnswerService,
        protected initialFilter?: any,
    ) {
        super(initialFilter);
    }

    load(): void {
        if (!this.isOpenedNewTab) {
            // Init filter with data source's default filter
            const filterValue: any = { ...this.initialFilter, ...this.filter };

            // If filter keyword exists, filter data
            if (this.keyword) {
                filterValue.searchText = this.keyword;
            }

            // Update loading state
            this.loadingSubject.next(true);

            // Create request parameters
            const request = this.getRequest();
            if (!request.orderType) {
                request.orderType = 'ASC';
                request.orderBy = 'createdOn';
            }

            if (this.paginator?.pageSize) {
                request.pageSize = this.paginator.pageSize;
            }

            // Add filters to request
            request.filter = filterValue;

            // Fetch data
            this.questionAnswerService
                .search(request)
                .pipe(
                    tap(() => this.request$.next(request)),
                    debounceTime(400),
                    finalize(() => this.loadingSubject.next(false))
                ).subscribe(response => {
                    // Update count and data subjects
                    this.dataSubject.next(response.data.results);
                    this.dataCountSubject.next(response.data.rowCount);
                    this.rowCount$.next(response.data.rowCount);

                    // Update data source's empty based row count
                    this.empty = response.data.rowCount === 0;
                });
        }

        return this.loadingSubject.next(false);
    }
}
